import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { WidgetValueSummary } from 'report/types';

const WidgetResultContext = React.createContext<WidgetValueSummary | undefined>(undefined);

export default singleton('contexts.TestContext', () => WidgetResultContext);
